import React from 'react'

const DocumentViewer = ({ url, onClick, className = '' }) => {
    // Détermine si le document est un PDF ou une image
    const isPdf =
        url.toLowerCase().endsWith('.pdf') || url.includes('application/pdf')

    return isPdf ? (
        <div
            className={`${className} flex cursor-pointer items-center justify-center bg-gray-100`}
            onClick={onClick}
        >
            <div className="flex flex-col items-center p-2">
                <i className="fas fa-file-pdf mb-2 text-3xl text-red-500"></i>
                <span className="text-sm font-medium text-gray-700">
                    Cliquer pour voir le PDF
                </span>
            </div>
        </div>
    ) : (
        <img
            src={url}
            alt="Document"
            className={`${className} cursor-pointer object-contain`}
            onClick={onClick}
        />
    )
}

export default DocumentViewer
